import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmPromotionClickDelegator {
	constructor() {
		this.type = GtmTrackingType.PROMO_CLICK;
		this.preventDefault = true;
		this.openInNewTab = false;

		this.dataMapper = [
			{
				dataName: 'data-promo-id',
				gtmKey: 'id',
			},
			{
				dataName: 'data-promo-name',
				gtmKey: 'name',
			},
			{
				dataName: 'data-promo-creative',
				gtmKey: 'creative',
			},
			{
				dataName: 'data-promo-position',
				gtmKey: 'position',
			},
		];
	}

	getTrackingData(target) {
		this.target = target;

		return {
			event: 'promotionClick',
			ecommerce: {
				promoClick: {
					actionField: {
						list: TrackingHelperInstance.generateActionFieldString(),
					},
					promotions: [
						TrackingHelperInstance.getRequiredDataAsObject(
							target,
							this.dataMapper,
						),
					],
				},
			},
			eventCallback: !this.openInNewTab ? this.callback.bind(this) : null,
		};
	}

	callback() {
		window.location.assign(this.target.href);
	}
}

const GtmPromotionClickDelegatorInstance = new GtmPromotionClickDelegator();
export default GtmPromotionClickDelegatorInstance;

// for test purpose only
export const GtmPromotionClickDelegatorClass = GtmPromotionClickDelegator;
